<script>
	import {link} from 'svelte-routing';
</script>

<div class="image-background">
    <h1 class="header_text_wrapper text-left"><span>COCKTAIL PACKAGE</span><span class="separator"></span></h1>
</div>
<div class="page-pattern">
    <div class="d-flex h-content align-items-center" style="min-height: 331px; margin-top: 20px;">
        <div class="container-fluid">
            <div class="half-box d-flex flex-column justify-content-start">
                <h2>Gallery</h2>
                <p>
                    Relish Unlimited cocktails and BBQ for 90 min ending with dancing to the music played by our Dj under the mist!
                </p>
            </div>
       
            <div class="half-box">
                
            </div>
        </div>
    </div>
    <div class="d-flex flex-container gap-10" style="margin-top: 35px; margin-bottom: 35px;">
        <div class="container-fluid">
            <div class="d-flex">
                <div class="half-box p-15">
                    <div class="vc_column-inner ">
                        <div class="wpb_wrapper">
                            <h2 class="calluna-heading calluna-heading-single-line text-align-left "><span>About</span></h2>
                            <div class="wpb_text_column wpb_content_element ">
                                <div class="wpb_wrapper">
                                    <p>Relish Unlimited cocktails and BBQ for 90 min ending with dancing to the &nbsp;music played by our Dj under the mist!</p>
                                    <p>Duration : 3pm to 10pm</p>
                                    <p><a class="calluna-recent-posts-entry-img calluna-shortcodes-lightbox" href="/images/cocktail_package.jpg">View Details</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="half-box p-15">
                    <div class="vc_column-inner ">
                        <div class="wpb_wrapper">
                            <h2 class="calluna-heading calluna-heading-single-line text-align-left "><span>Details</span></h2>
                            <div class="wpb_text_column wpb_content_element ">
                                <div class="wpb_wrapper">
                                    <p>What's included</p>
                                    <p>We serve liquor to 21years and above only
                                        <br> Minimum group size : 50 (Adults only).</p>
                                    <div class="calluna-callout calluna-clearfix  ">
                                        <div class="calluna-callout-caption">Per Person Rs. 1,750</div>
                                        <div class="calluna-callout-button"><a href="contact" target="_top" use:link class="calluna-button btn btn-primary default style-2" title="Callout button"><span class="calluna-button-inner">Book Your Getaway</span></a></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<style>
	.image-background {
        background: url("../images/Cocktail-Package-image.jpg") no-repeat center;
    }
    
    .page-pattern {
		background: #fff;
	}

    .h-content {
        background: #0f2453 !important;
    }

    .half-box {
        width: 50%;
    }

    .h-content .half-box {
        width: 50%;
    }

    h2 {
        color: #967a50;
        margin-left: 10px;
    }
    
    p {
        font-size: 1.125rem;
        line-height: 2rem;
        color: #fff;;
    }

    .wpb_wrapper p {
        color: #444444;
    }

    .p-15 {
        padding: 15px;
    }

    .calluna-callout {
        padding: 42px;
        background: #f1f2f2;
        position: relative;
    }

    .calluna-callout-caption {
        font-size: 1rem;
        font-weight: 400;
        margin-bottom: 25px;
    }

    /* Responsive layout - makes a one column-layout instead of two-column layout */
    @media (max-width: 800px) {
        .flex-container {
            flex-direction: column;
        }
    }
</style>